import {envUtil} from '@/helper/env';

export async function pixelTrackRegister(channel: 'email' | 'google' | 'twitter' | 'WalletConnect' | 'MetaMask' | 'telegram') {
  if (envUtil.isProduction) {
    // @ts-ignore
    window.bxtag('event', 'register', {desc: channel || 'email'});
    return await sleep(1000);
  } else {
    return Promise.resolve();
  }
}

function sleep(ms = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(1);
    }, ms);
  });
}
